var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['page-' + _vm.$router.currentRoute.name.toLowerCase(), _vm.$router.currentRoute.meta.topClass ? 'top-' + _vm.$router.currentRoute.meta.topClass : ''],attrs:{"id":"app"}},[_c('div',{attrs:{"id":"wrapper"}},[_c('keep-alive',{attrs:{"max":"2"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d901f80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 